if (window.swymcsInitialized) {
  console.warn("Swym already initialized");
} else {
  window.swymcsInitialized = true;

  console.log("Swym Custom Wishlist Loaded");

/* ================= INIT ================= */

const init = async (swat) => {
  await fetchList(swat);

  if (!window.swymSelectedListId) {
    createList(swat);
  }

  addEvents(swat);
};

/* ================= CREATE LIST ================= */

const createList = (swat) => {
  swat.createList(
    { lname: "My Wishlist" },
    ({ lid }) => {
      window.swymSelectedListId = lid;
    },
    (err) => console.error(err)
  );
};

/* ================= FETCH ================= */

const fetchList = async (swat) => {
  return new Promise((resolve, reject) => {
    swat.fetchLists({
      callbackFn: (lists) => {
        window.swymWishLists = lists;
        window.swymSelectedListId = lists?.[0]?.lid;

        updateButtons();
        resolve(lists);
      },
      errorFn: reject,
    });
  });
};

/* ================= REFRESH ================= */

const refreshWishlist = async (swat) => {
  window.swymWishLists = null;
  await fetchList(swat);
};

/* ================= UI ================= */

const setActive = (el, isActive) => {
  const filled = el.querySelector("#swymFilled");
  const unfilled = el.querySelector("#swymUnfilled");

  if (!filled || !unfilled) return;

  if (isActive) {
    filled.style.display = "block";
    unfilled.style.display = "none";
    el.classList.add("swym-added-custom");
  } else {
    filled.style.display = "none";
    unfilled.style.display = "block";
    el.classList.remove("swym-added-custom");
  }
};

/* ================= ADD ================= */

const addToWishlist = (swat, product, el) => {
  // 🔥 instant UI
  setActive(el, true);

  swat.addToList(
    window.swymSelectedListId,
    product,
    async () => {
      await refreshWishlist(swat); // ✅ FIX
    },
    () => {
      setActive(el, false);
    }
  );
};

/* ================= REMOVE ================= */

const removeFromWishlist = (swat, product, el) => {
  setActive(el, false);

  swat.deleteFromList(
    window.swymSelectedListId,
    product,
    async () => {
      await refreshWishlist(swat); // ✅ FIX
    },
    () => {
      setActive(el, true);
    }
  );
};

/* ================= SYNC ================= */

const updateButtons = () => {
  document.querySelectorAll("swymcs-wishlist-button").forEach((el) => {
    let { epi, empi } = el.dataset;

    let found = false;

    window.swymWishLists?.forEach((list) => {
      list.listcontents.forEach((item) => {
        if (item.epi == epi && item.empi == empi) {
          found = true;
        }
      });
    });

    setActive(el, found);
  });
};

/* ================= EVENTS ================= */

const addEvents = (swat) => {
  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => {
    refreshWishlist(swat);
  });

  swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, () => {
    refreshWishlist(swat);
  });
};

/* ================= COMPONENT ================= */

if (!customElements.get("swymcs-wishlist-button")) {

  class SwymWishlistButton extends HTMLElement {
    constructor() {
      super();

      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(this.init.bind(this));
    }

    init(swat) {
      this.addEventListener("click", () => {
        let { epi, empi, du } = this.dataset;
        let product = { epi, empi, du };

        const isAdded = this.classList.contains("swym-added-custom");

        if (isAdded) {
          removeFromWishlist(swat, product, this);
        } else {
          addToWishlist(swat, product, this);
        }
      });
    }
  }

  customElements.define("swymcs-wishlist-button", SwymWishlistButton);
}

/* ================= INIT ================= */

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(init);

}